export default "__VITE_ASSET__50393111__"